import type { ReactNode } from 'react';

import GridLayout from '@/routes/Client/Cage/pages/Reports/shared/GridLayout';

import styles from './HealthDetailTemplate.module.scss';

/**
 * The panel is a `ContentBlock`, whose `min-width` is 320px, so the column is exactly that
 * wide and the card fills it.
 */
const INFORMATION_PANEL_WIDTH = 320;

export interface HealthDetailTemplateProps {
    statusChart: ReactNode;
    developmentChart: ReactNode;
    informationPanel: ReactNode;
    detections: ReactNode;
}

/**
 * Shared detail layout: Status | Development above Detections in the main column, with the
 * information panel beside them.
 *
 * The panel sits in its own column rather than spanning the chart rows, so its height (which
 * varies with each parameter's copy) cannot stretch the chart cards.
 */
export default function HealthDetailTemplate(props: HealthDetailTemplateProps) {
    const { statusChart, developmentChart, informationPanel, detections } = props;

    return (
        <div className={styles.detailLayout} data-testid="health-detail-template">
            <GridLayout
                contentLayout="1-fixed-fluid"
                secondColumnWidth={INFORMATION_PANEL_WIDTH}
                gap="small"
                alignItems="start">
                <div className={styles.mainColumn}>
                    <GridLayout contentLayout="2-fluid" gap="small">
                        {statusChart}
                        {developmentChart}
                    </GridLayout>
                    <section className={styles.detectionsSection}>{detections}</section>
                </div>
                <div className={styles.infoColumn}>{informationPanel}</div>
            </GridLayout>
        </div>
    );
}
